import "./index.css";
import "./textScale.css";
import "./i18n";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";
import { initMsal, restoreEntraSession } from "./auth/msalConfig";
import { ThemeProvider } from "./context/ThemeContext";
import { BrandingProvider, fetchBranding } from "./context/BrandingContext";
import { App } from "./App";

// Async IIFE — avoids top-level await which is unsupported in the ES2020 target.
// Fetches white-label branding first so MSAL is initialised with the correct
// Entra app registration for the current domain before React renders.
(async () => {
  const branding = await fetchBranding();

  const clientId  = branding?.entraClientId  ?? import.meta.env.VITE_ENTRA_CLIENT_ID;
  const authority = branding?.entraAuthority ?? import.meta.env.VITE_ENTRA_AUTHORITY;

  const msalInstance = initMsal(clientId, authority);
  await msalInstance.initialize();
  await restoreEntraSession(msalInstance, clientId);

  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <BrandingProvider initialBranding={branding}>
        <ThemeProvider>
          <MsalProvider instance={msalInstance}>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </MsalProvider>
        </ThemeProvider>
      </BrandingProvider>
    </React.StrictMode>
  );
})();
